module.exports = __webpack_public_path__ + "static/media/yy4.ac1e1d2a.png";